<template>
	<div
		:class="classes"
		class="alert"
		style="padding: 10px; display: flex; margin-bottom: 12px"
	>
		<div style="width: 26px; display: flex; align-items: center">
			<slot name="icon" />
		</div>
		<div style="width: calc(100% - 34px); padding-top: 2px">
			<slot />
		</div>
	</div>
</template>

<script>
import AlertMixin from './AlertMixin.js'
export default {
	mixins: [AlertMixin]
}
</script>

<style scoped>
.alert-light {
	color: #4d4d4d;
	background-color: #efefef;
	border-color: #dcdcdc;
}
</style>
